<template>
<div class="chapter">
<div class="inner_page">
<p class="tit" id="tit"><img alt="image" src="images/title.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3fec3c7b